import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SummaryFilterModel } from '../../../../../models/summary/summary.model';

@Component({
  selector: 'app-translate-icon',
  templateUrl: './translate-icon.component.html',
  styleUrls: ['./translate-icon.component.less']
})
export class TranslateIconComponent implements OnInit {

  constructor() { }  
  @Input() isOnTranslate: boolean
  @Input() isCompareMode: boolean
  @Input() versionName: string;
  @Input() isOnTheme: boolean;
  
  @Input() versionTranslate: SummaryFilterModel;
  @Output() onTranlateAction = new EventEmitter<boolean>()

  ngOnInit() {
  }

  _onTranslateAction(): void {
    if (this.versionName !== this.versionTranslate.version) {        
      this.isOnTranslate = !this.isOnTranslate
      this.onTranlateAction.emit(this.isOnTranslate)
    }
  }

  

}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/icon-dropdown/translate-icon/translate-icon.component.ts